import ApiBase from './ApiBase'
import {Card, IdResponse, Deck} from '../model/models'
import ApiResponse from '../model/ApiResponse'

export default class DeckApi extends ApiBase {
  async createDeck(title: string, description: string, imageFile: any, tags: string[]): Promise<ApiResponse<IdResponse | null>> {
    let data = new FormData()
    data.set('Title', title)
    data.set('Description', description)
    data.set('ImageFile', imageFile)

    for (const i in tags) {
      data.append(`Tags[${i}]`, tags[i])
    }
    
    return await this.post<IdResponse>('deck/create', data)
  }

  async getDeck(id: number): Promise<ApiResponse<Deck | null>> {
    return await this.get<Deck>(`deck/${id}`)
  }
  
  async getDeckWithoutCards(id: number): Promise<ApiResponse<Deck | null>> {
    return await this.get<Deck>(`deck/without-cards/${id}`)
  }

  async getAllUserDecks(): Promise<ApiResponse<Deck[] | null>> {
    return await this.get<Deck[]>(`deck/all`)
  }

  async getPublicDecksWithoutCards(): Promise<ApiResponse<Deck[] | null>> {
    return await this.get<Deck[]>(`deck/public`)
  }

  async getAllDecksByTag(tag: string) {
    return await this.get<Deck[]>(`deck/tag/${tag}`)
  }

  async updateDeck(deckId: number, title: string, description: string, imageFile: any, updateImage: boolean, tags: string[], isPublic: boolean ): Promise<ApiResponse<IdResponse | null>> {
    let data = new FormData()
    data.set('Title', title)
    data.set('Description', description)
    data.set('ImageFile', imageFile)
    data.set('UpdateImage', JSON.stringify(updateImage))
    data.set('IsPublic', JSON.stringify(isPublic))

    for (const i in tags) {
      data.append(`Tags[${i}]`, tags[i])
    }
    
    return await this.post<IdResponse>(`deck/${deckId}/update`, data)
  }

  async deleteDeck(id: number) {
    await this.delete(`deck/${id}`)
  }

  async createCard(deckId: number, frontText: string, backText: string, frontFile: any, backFile: any): Promise<ApiResponse<IdResponse | null>> {
    let data = new FormData()
    data.set('FrontText', frontText)
    data.set('BackText', backText)
    data.set('FrontImageFile', frontFile)
    data.set('BackImageFile', backFile)
    return await this.post<IdResponse>(`deck/${deckId}/card`, data)
  }

  async getCard(deckId: number, cardId: number): Promise<ApiResponse<Card | null>> {
    return await this.get<Card>(`deck/${deckId}/card/${cardId}`)
  }

  async updateCard(deckId: number, cardId: number, frontText: string, backText: string,
                   frontImageFile: any, backImageFile: any, updateFrontImage: boolean, updateBackImage: boolean): Promise<ApiResponse<Card | null>> {
    let data = new FormData()
    data.set('DeckId', deckId.toString())
    data.set('FrontText', frontText || '')
    data.set('BackText', backText || '')
    data.set('FrontImageFile', frontImageFile)
    data.set('BackImageFile', backImageFile)
    data.set('UpdateFrontImage', JSON.stringify(updateFrontImage))
    data.set('UpdateBackImage', JSON.stringify(updateBackImage))
    return await this.post<Card>(`deck/${deckId}/card/${cardId}/update`, data)
  }
  
  async updateCardEnabled(deckId: number, cardId: number, enabled: boolean): Promise<ApiResponse<any>> {
    return await this.post<any>(`deck/${deckId}/card/${cardId}/${enabled}`, {})
  }
  
  async deleteCard(deckId: number, cardId: number) {
    await this.delete(`deck/${deckId}/card/${cardId}`)
  }
  
  async copyDeck(deckId: number): Promise<ApiResponse<IdResponse | null>> {
    return await this.post<IdResponse>(`deck/${deckId}/copy`, {})
  }

  async getCopiedId(deckId: number): Promise<ApiResponse<IdResponse | null>> {
    return await this.post<IdResponse>(`deck/${deckId}/copied-id`, {})
  }
}
